import { render, staticRenderFns } from "./CrmEditGeneral.vue?vue&type=template&id=3a20e67e"
import script from "./CrmEditGeneral.vue?vue&type=script&lang=ts"
export * from "./CrmEditGeneral.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a20e67e')) {
      api.createRecord('3a20e67e', component.options)
    } else {
      api.reload('3a20e67e', component.options)
    }
    module.hot.accept("./CrmEditGeneral.vue?vue&type=template&id=3a20e67e", function () {
      api.rerender('3a20e67e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/crm/CrmEditGeneral.vue"
export default component.exports